import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

const RemoveControl = ({ iconSize, onClick }) => (
  <FontAwesomeIcon
    className="clickable text-danger"
    icon={faTrash}
    size={iconSize}
    onClick={onClick}
  />
);

RemoveControl.propTypes = {
  iconSize: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export default RemoveControl;
